var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"one-bd clearfix"},[_c('div',{staticClass:"fl"},[_c('router-link',{attrs:{"to":"/personalCenter","exact":""}},[_vm._v("会员权益")]),_vm._v(" "),(_vm.$parent.$parent.vipInfo.level != 20)?_c('router-link',{attrs:{"to":"/personalCenter/permissionComparison"}},[_vm._v("会员购买")]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-476e88d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/personalCenter/vipMenu.vue
// module id = null
// module chunks = 